module.exports = __webpack_public_path__ + "media/images/items/thumbnail-2-9959ff9331390dc3a0563bbfcab76007.jpg";